// ============================================================================
// KOSARAJU SCC - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kosaraju-scc',
  name: 'Kosaraju SCC',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'An algorithm for finding strongly connected components in a directed graph. It uses two passes of DFS: first to compute finishing times, then on the transposed graph to identify SCCs.'
};
